import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { YamsCoreController } from "./YamsCoreController";
export var YAMS_ZERO_ZOOM = 16;
export var YamsController = /*#__PURE__*/function (_YamsCoreController) {
  function YamsController() {
    var _this;
    _classCallCheck(this, YamsController);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, YamsController, [].concat(args));
    _defineProperty(_this, "scaleToZoom", function (value) {
      return value * Math.pow(2, YAMS_ZERO_ZOOM - _this.zoom);
    });
    _defineProperty(_this, "setBounds", function (boundedBy) {
      return _this.inst.setBounds(boundedBy);
    });
    return _this;
  }
  _inherits(YamsController, _YamsCoreController);
  return _createClass(YamsController, [{
    key: "zoom",
    get: function get() {
      return this.inst.getZoom();
    }
  }, {
    key: "bounds",
    get: function get() {
      return this.inst.getBounds();
    }
  }]);
}(YamsCoreController);